<template>
  <div class="homicides-container">
    <span class="homicides-label">
      Homicides by cause of death per month in {{ year }}
    </span>
    <chartist
      ratio="ct-major-second"
      type="Bar"
      :data="causeData"
      :options="options"
      :responsive-options="responsiveOptions"
    />
    <ul class="legend-list">
      <li
        v-for="(label, i) in labels"
        :key="label"
        :class="legendClass(i)"
      >{{ label }}</li>
    </ul>
  </div>
</template>

<script>
const emptyArray = () => {
  let arr = [];
  for (let i = 0; i < 12; i++) arr.push(0);
  return arr;
};

export default {
  name: "CauseChart",
  props: {
    allVictims: Array,
    year: String
  },
  data() {
    return {
      months: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
      ],
      causeNames: [
        ["shooting", "Shooting"],
        ["stabbing", "Stabbing"],
        ["bluntforce", "Blunt Force"],
        ["asphyxiation", "Asphyxiation"],
        ["other", "Other"],
        ["unknown", "Unknown"]
      ]
    };
  },
  methods: {
    legendClass(i) {
      let className = `legend-${i}`;
      return {
        [className]: true
      };
    }
  },
  computed: {
    responsiveOptions() {
      return [
        [
          "screen and (max-width: 780px)",
          {
            axisX: {
              labelInterpolationFnc: value => {
                return value.split(/\W/)[1] || value;
              }
            }
          }
        ]
      ];
    },
    options() {
      return {
        stackBars: true,
        axisX: { showGrid: false },
        axisY: {
          low: 0,
          referenceValue: 45,
          onlyInteger: true
        }
      };
    },
    causeData() {
      // Build a container for return value
      let series = this.causeNames.map(() => emptyArray());
      let totals = emptyArray();

      let causeIdx = {};
      this.causeNames.forEach(([abbr], index) => {
        causeIdx[abbr] = index;
      });

      this.allVictims.forEach(victim => {
        if (victim.year === this.year) {
          let i = causeIdx[victim.cause];
          let monthIdx = victim.monthNumber - 1;
          series[i][monthIdx]++;
          totals[monthIdx]++;
        }
      });

      let labels = this.months.map(
        (month, i) => (totals[i] === 0 ? month : `${month}\n${totals[i]}`)
      );

      return { labels, series };
    },
    labels() {
      return this.causeNames.map(([, label]) => label);
    }
  }
};
</script>

<style lang="scss">
</style>
